import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { IState } from '../../../../common/store/types';

export interface ICallState extends IState<unknown> {}

export const callInitialState: ICallState = {};

const callReducers = [];

export const callReducer = createReducer(
  callInitialState,
  ...callReducers,
) as ActionReducer<ICallState, Action>;

export function useReducerFunc(state: any | undefined, action: Action) {
  return callReducer(state, action);
}
